import { EventEnvelop } from './event-sourcing';
import { MessageBusTransportStats } from './message-bus-transport-stats';
import { ICommit, IDisposable, IMessageBusTransport, IMessageBusTransportSetup } from './models';
import { Queue } from './queue';

export abstract class AbstractMessageBusTransport implements IMessageBusTransport, IDisposable {

    protected stats: MessageBusTransportStats;
    protected options: any;
    protected maxRetries = 5;
    protected inputQueue = new Queue<EventEnvelop>();
    protected outputQueue = new Queue<ICommit>();
    protected buffer = new Queue<ICommit>();

    abstract send(event): Promise<boolean> | boolean;

    abstract append(event): Promise<boolean>;

    abstract dispose();

    abstract commit();

    abstract sendAll();

    setup(options: IMessageBusTransportSetup): void {
        this.options = options;
        this.maxRetries = options?.maxRetries || 5;
    }

    abstract getStats(): MessageBusTransportStats

}
